<template>
  <div id="app">
    <div id="MainWrapper">
      <rwv-header></rwv-header>
      <router-view/>
      <rwv-footer></rwv-footer>
    </div>
  </div>
</template>
<script>
import * as $ from 'jquery'
import 'paroller.js';

import RwvHeader from '@/components/Header'
import RwvFooter from '@/components/Footer'
export default {
  name: 'App',
  components: { RwvHeader, RwvFooter },
  mounted() {
    $.fn.easeScroll = function(options) {
      ! function() {
        function e() {
          var e = !1;
          e && c("keydown", r), v.keyboardSupport && !e && u("keydown", r)
        }

        function t() {
          if (document.body) {
            var t = document.body,
              o = document.documentElement,
              n = window.innerHeight,
              r = t.scrollHeight;
            if (S = document.compatMode.indexOf("CSS") >= 0 ? o : t, w = t, e(), x = !0, top != self) y = !0;
            else if (r > n && (t.offsetHeight <= n || o.offsetHeight <= n)) {
              var a = !1,
                i = function() {
                  a || o.scrollHeight == document.height || (a = !0, setTimeout(function() {
                    o.style.height = document.height + "px", a = !1
                  }, 100))
                };
              if (o.style.height = "auto", setTimeout(i, 10), S.offsetHeight <= n) {
                var l = document.createElement("div");
                l.style.clear = "both", t.appendChild(l)
              }
            }
            v.fixedBackground || b || (t.style.backgroundAttachment = "scroll", o.style.backgroundAttachment = "scroll")
          }
        }

        function o(e, t, o, n) {
          if (n || (n = 1e3), d(t, o), 1 != v.accelerationMax) {
            var r = +new Date,
              a = r - C;
            if (a < v.accelerationDelta) {
              var i = (1 + 30 / a) / 2;
              i > 1 && (i = Math.min(i, v.accelerationMax), t *= i, o *= i)
            }
            C = +new Date
          }
          if (M.push({
              x: t,
              y: o,
              lastX: 0 > t ? .99 : -.99,
              lastY: 0 > o ? .99 : -.99,
              start: +new Date
            }), !T) {
            var l = e === document.body,
              u = function() {
                for (var r = +new Date, a = 0, i = 0, c = 0; c < M.length; c++) {
                  var s = M[c],
                    d = r - s.start,
                    f = d >= v.animationTime,
                    h = f ? 1 : d / v.animationTime;
                  v.pulseAlgorithm && (h = p(h));
                  var m = s.x * h - s.lastX >> 0,
                    w = s.y * h - s.lastY >> 0;
                  a += m, i += w, s.lastX += m, s.lastY += w, f && (M.splice(c, 1), c--)
                }
                l ? window.scrollBy(a, i) : (a && (e.scrollLeft += a), i && (e.scrollTop += i)), t || o || (M = []), M.length ? E(u, e, n / v.frameRate + 1) : T = !1
              };
            E(u, e, 0), T = !0
          }
        }

        function n(e) {
          x || t();
          var n = e.target,
            r = l(n);
          if (!r || e.defaultPrevented || s(w, "embed") || s(n, "embed") && /\.pdf/i.test(n.src)) return !0;
          var a = e.wheelDeltaX || 0,
            i = e.wheelDeltaY || 0;
          return a || i || (i = e.wheelDelta || 0), !v.touchpadSupport && f(i) ? !0 : (Math.abs(a) > 1.2 && (a *= v.stepSize / 120), Math.abs(i) > 1.2 && (i *= v.stepSize / 120), o(r, -a, -i), void e.preventDefault())
        }

        function r(e) {
          var t = e.target,
            n = e.ctrlKey || e.altKey || e.metaKey || e.shiftKey && e.keyCode !== H.spacebar;
          if (/input|textarea|select|embed/i.test(t.nodeName) || t.isContentEditable || e.defaultPrevented || n) return !0;
          if (s(t, "button") && e.keyCode === H.spacebar) return !0;
          var r, a = 0,
            i = 0,
            u = l(w),
            c = u.clientHeight;
          switch (u == document.body && (c = window.innerHeight), e.keyCode) {
            case H.up:
              i = -v.arrowScroll;
              break;
            case H.down:
              i = v.arrowScroll;
              break;
            case H.spacebar:
              r = e.shiftKey ? 1 : -1, i = -r * c * .9;
              break;
            case H.pageup:
              i = .9 * -c;
              break;
            case H.pagedown:
              i = .9 * c;
              break;
            case H.home:
              i = -u.scrollTop;
              break;
            case H.end:
              var d = u.scrollHeight - u.scrollTop - c;
              i = d > 0 ? d + 10 : 0;
              break;
            case H.left:
              a = -v.arrowScroll;
              break;
            case H.right:
              a = v.arrowScroll;
              break;
            default:
              return !0
          }
          o(u, a, i), e.preventDefault()
        }

        function a(e) {
          w = e.target
        }

        function i(e, t) {
          for (var o = e.length; o--;) z[N(e[o])] = t;
          return t
        }

        function l(e) {
          var t = [],
            o = S.scrollHeight,
            overflow = getComputedStyle(e, "").getPropertyValue("overflow-y");
          do {
            var n = z[N(e)];
            if (n) return i(t, n);
            if (t.push(e), o === e.scrollHeight) {
              if (!y || S.clientHeight + 10 < o) return i(t, document.body)
            } else if (e.clientHeight + 10 < e.scrollHeight && (overflow = getComputedStyle(e, "").getPropertyValue("overflow-y"), "scroll" === overflow || "auto" === overflow)) return i(t, e)
          } while (e = e.parentNode)
        }

        function u(e, t, o) {
          window.addEventListener(e, t, o || !1)
        }

        function c(e, t, o) {
          window.removeEventListener(e, t, o || !1)
        }

        function s(e, t) {
          return (e.nodeName || "").toLowerCase() === t.toLowerCase()
        }

        function d(e, t) {
          e = e > 0 ? 1 : -1, t = t > 0 ? 1 : -1, (k.x !== e || k.y !== t) && (k.x = e, k.y = t, M = [], C = 0)
        }

        function f(e) {
          if (e) {
            e = Math.abs(e), D.push(e), D.shift(), clearTimeout(A);
            var t = D[0] == D[1] && D[1] == D[2],
              o = h(D[0], 120) && h(D[1], 120) && h(D[2], 120);
            return !(t || o)
          }
        }

        function h(e, t) {
          return Math.floor(e / t) == e / t
        }

        function m(e) {
          var t, o, n;
          return e *= v.pulseScale, 1 > e ? t = e - (1 - Math.exp(-e)) : (o = Math.exp(-1), e -= 1, n = 1 - Math.exp(-e), t = o + n * (1 - o)), t * v.pulseNormalize
        }

        function p(e) {
          return e >= 1 ? 1 : 0 >= e ? 0 : (1 == v.pulseNormalize && (v.pulseNormalize /= m(1)), m(e))
        }

        var settings = $.extend({
          // These are the defaults.
          frameRate: 60,
          animationTime: 1000,
          stepSize: 120,
          pulseAlgorithm: !0,
          pulseScale: 8,
          pulseNormalize: 1,
          accelerationDelta: 20,
          accelerationMax: 1,
          keyboardSupport: !0,
          arrowScroll: 50,
          touchpadSupport: !0,
          fixedBackground: !0
        }, options);

        var w, g = {
            frameRate: settings.frameRate,
            animationTime: settings.animationTime,
            stepSize: settings.stepSize,
            pulseAlgorithm: settings.pulseAlgorithm,
            pulseScale: settings.pulseScale,
            pulseNormalize: settings.pulseNormalize,
            accelerationDelta: settings.accelerationDelta,
            accelerationMax: settings.accelerationMax,
            keyboardSupport: settings.keyboardSupport,
            arrowScroll: settings.arrowScroll,
            touchpadSupport: settings.touchpadSupport,
            fixedBackground: settings.fixedBackground,
            excluded: ""
          },
          v = g,
          b = !1,
          y = !1,
          k = {
            x: 0,
            y: 0
          },
          x = !1,
          S = document.documentElement,
          D = [120, 120, 120],
          H = {
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            spacebar: 32,
            pageup: 33,
            pagedown: 34,
            end: 35,
            home: 36
          },
          v = g,
          M = [],
          T = !1,
          C = +new Date,
          z = {};
        setInterval(function() {
          z = {}
        }, 1e4);
        var A, N = function() {
            var e = 0;
            return function(t) {
              return t.uniqueID || (t.uniqueID = e++)
            }
          }(),
          E = function() {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || function(e, t, o) {
              window.setTimeout(e, o || 1e3 / 60)
            }
          }(),
          K = /chrome|iPad/i.test(window.navigator.userAgent),
          L = "onmousewheel" in document;
        L && K && (u("mousedown", a), u("mousewheel", n), u("load", t))
      }();
    }

    $("html").easeScroll({
      frameRate: 25,
      animationTime: 1500,
      stepSize: 80
    });
    $('.parallax-background').paroller();
    
  },
  updated(){
    $('.parallax-background').paroller();
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Ubuntu:300,400,500');
@import url('./assets/css/bootstrap.min.css');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
@mixin vertical-align($position: relative) {
  position: $position;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
@mixin border-radious($radious: 10px){
  -webkit-border-radius: $radious;
  -moz-border-radius: $radious;
  border-radius: $radious;
}
$Primary-font: 'Ubuntu', sans-serif;
$Primary-font-color: #304775;
$Primary-font-size: 25px;

$White: #fff;
$Blue: #113170;
$Gray:#525252;

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
  outline: none;
}


ul {
  list-style-type: circle;
}
.float-left{float: left;}
.float-right{float: right;}

a {
  color: $Primary-font-color;
  text-decoration: none;
}
a:hover{ text-decoration: none;  }


.error{ color: #dc3c31 !important; font-weight: 500; }
.success{ color: #74d343 !important; font-weight: 500; }


p{ font-weight:400; }
/********    TEXT  CASE & SIZE  ********/
/***************************************/
.fs-base {
  font-size: $Primary-font-size;
}
.fs0 {
  font-size: 0.9em;
}
.fs1{ 
  font-size: 1.1em; 
}
.fs2 {
  font-size: 1.3em;
}
.fs3 {
  font-size: 1.8em;
}
.fs4 {
  font-size: 2em;
}
.fs5 {
  font-size: 2.4em;
}

.lh1{ line-height:1em; }
.lh1-3{ line-height:1.3em; }
.lh1-5{ line-height:1.5em; }



.uppercase {
  text-transform: uppercase;
}
.capitalize{
 text-transform: capitalize;
}

strong {
  font-weight: 500;
}
.normal{ font-weight:400; }
.light{ font-weight:300; }

.wrt_ul{
  list-style:none; margin-left: 0px;
  li{ background: url('./assets/img/bullet.png') no-repeat left top; padding-left:35px; }
}


/***********    TEXT COLORS  ***********/
/***************************************/

.white{ color:$White; }
.blue{ color:$Blue; }
.gray{ color:$Gray; }

.whiteBg{ background:$White; }
.blueBg{ background:$Blue; }
.grayBg{ background:$Gray; }
.lightGrayBg{ background:#eef0f3; }


/***********    OTHER  ***********/
/***************************************/
.responsive{ 
  width:100%; height:auto; 
}

img {
  border: none;
}


.clear {
  clear: both;
}

.content-padding {
  width: 95%;
  margin: 0px auto;
  position: relative;
}



/**********    TEXT  ALIGNMENT  ********/
/***************************************/

.T_alignLeft {
  text-align: left;
}

.T_alignRight {
  text-align: right;
}

.T_alighCenter {
  text-align: center !important;
}



/********         PADDINGS      ********/
/***************************************/

.row-no-margin {
    margin-left: 0 !important;
    margin-right: 0 !important;
}

.no-padding{
  padding: 0 !important;
}

.row-no-padding > [class*="col-"], .no-padding-left-right {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.row-no-padding-right > [class*="col-"], .no-padding-right{
    padding-right: 0 !important;
}
.row-no-padding-left > [class*="col-"], .no-padding-left {
    padding-left: 0 !important;
}

.no-padding-top{ padding-top:0px !important; }
.no-padding-bottom{ padding-bottom:0px !important; }

.padding_16{ padding:16px; }
.padding_l_32, .padding_lr_32{ padding-left:32px; }
.padding_r_32, .padding_lr_32{ padding-right:32px; }

.padding_t_8, .padding-tb-8{ padding-top:8px; }
.padding_b_8, .padding-tb-8{ padding-bottom:8px; }

.padding_t_16, .padding-tb-16{ padding-top:16px; }
.padding_b_16, .padding-tb-16{ padding-bottom:16px; }



/********         DISPLAY      ********/
/***************************************/

.inline{ display: inline-block; }
.block{ display: block; }

.left{ float:left;}
.right{ float:right;}

.relative{ position:relative; }

.verticle-middle{ vertical-align:middle; }

/********         INPUTS      ********/
/***************************************/

input, select, textarea{ 
  border:1px solid #ccc; 
  padding:5px; 
  font-family: $Primary-font; 
  font-size: 1em; 
  font-weight: 400; 
  margin:8px 0px;
}
input:focus { outline:none; }


article{ position:relative; }


.button{ padding:13px 40px; }

/*************   SITE CSS   ************/
/***************************************/


#MainWrapper{
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
}

  .ContentAligher{
    width:90%;
    margin:0px 5% 0px 5%;
    display:block;
    position:relative;
  }

   #HeaderBar{
    padding-top:15px; 
    background: #d2d5dc;
    background: -moz-linear-gradient(top, #d2d5dc 0%, #cbcbcb 50%, #dae0ec 100%);
    background: -webkit-linear-gradient(top, #d2d5dc 0%,#cbcbcb 50%,#dae0ec 100%);
    background: linear-gradient(to bottom, #d2d5dc 0%,#cbcbcb 50%,#dae0ec 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d2d5dc', endColorstr='#dae0ec',GradientType=0 );
  }

  #LogoMenuWrapper{ 
    position:relative; padding:10px 0px; 
    #LogoWrapper{ display:inline-block; vertical-align:middle;  width: 207px;}
    #MenuWrapper{ 
      display:inline-block;  width: calc(100% - 407px); vertical-align:middle; padding-right:50px; 
      ul{
        list-style:none; float:right; margin:auto;
        li{ 
          display:inline-block; padding:10px 15px;
          a{ display:block;font-weight: 400;} 
        }
      }
      ul:after{
        clear:both; content:"";
      }
    }
    #QuickContactWrapper{ 
      width: 200px; display:inline-block; vertical-align:middle; 
      a{ display:inline-block; vertical-align:bottom; }
    }
  }


  #BannerWrapper{
    display:block;
    position:relative;
    #BannerImg{
      height: 0; padding-top:40%; width: 100%; background-size:cover; position:relative; z-index:10;
    }
    #BannerContent{ 
      z-index:11; padding:0px 5%;
      width: 70%; max-width:1000px; @include vertical-align(absolute);
      h1{ color:$White; }
      p{ color:$White; }
    }
  }
  
  .TBSpacing{ padding-top:150px; padding-bottom:150px; }

  article p, article li{ line-height:1.7em; }
  .TagLine{ font-size: 1.8em; font-weight: 300;     margin: -10px 0px -10px 0px;
    display: block; }

  #AboutDanAdvance{
    .ContentAligher{
      background:url(./assets/img/lion.svg) no-repeat right;
      background-size:contain;
    }
  }

  #KeyAdvantages{
    background:#dddddd url(./assets/img/key-advantage-bg.jpg) no-repeat right bottom;
    background-size:contain;
    li{ margin:18px 0px; }
  }

  #TheMCA{
    background:#143c8f url(./assets/img/the-mca-market-bg.jpg) no-repeat right bottom;
    background-size:cover;
    h1{ color:$White; }
    p{ color:$White; }
    .button{ color:$Blue; background:$White; display:inline-block; }
  }

  #MCAvis{
    background:#fff url(./assets/img/the-mca-vis-bg.jpg) no-repeat right bottom;
    background-size:contain;
    hr{ height:1px; padding:0px; margin:0px; }
  }


  #CTA{
    background:$Blue; text-align:center;
    h1{ color:$White; }
    .button{ background:$White; }
  }

  #Quotes{
    background:#dce1e2 url(./assets/img/quotes-bg.jpg) no-repeat left bottom;
    background-size:cover;
    text-align: center;
  }




.footer{background: #fcfcfc}
.c-footer__logo img{max-width: 220px;padding-bottom: 20px;width: 100%;}

.footer-top{padding: 30px 0px}
.social-links li{width: 25%;display: inline-block}
.footer-contact-us{padding-left: 30px;}
.footer-contact-us ul li:first-child {
    padding-top: 0px;
}
.footer-contact-us ul li {
    list-style: none;
    padding-bottom: 22px;
    padding-top: 22px;
}
.footer-contact-us ul li span img {max-width: 100%;}
.footer-contact-us ul li span {width: 90px;padding-right: 5px;}
.footer-contact-us ul li span, .footer-contact-details {display: inline-block;vertical-align: top;}
.footer-contact-details {padding-left: 15px;}

.footer-title {font-size: 1.1em;}

.footer-bottom{padding: 25px 0px;}

.footer-navigation{margin-bottom: 0px}
.footer-navigation li{display: inline-block}

.footer-navigation li a p {color: #7f7e7e;padding-right: 7px;padding-left: 7px;border-left: #7f7e7e solid 1.2px;
}
.footer-navigation li:first-child a p {border-left: none;padding-left: 0px;}

.footer-extra-link {
    padding: 0px;
    padding-top: 15px;
    padding-bottom: 35px
}
.footer-extra-link li{padding-bottom: 5px}

@import './assets/styles/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue